module.exports = __webpack_public_path__ + "6f8391bbdaeaa540388796c858dfd8ca.ttf";